import { ImageAnnotations, Viewport } from 'app/interfaces/Image';
import { computeScaleFactorFromStoredViewport } from 'app/utils/cornerstone/imageUtils';
import { convertCropAnnotationsToCropRect } from 'app/utils/image/convertCropAnnotationsToCropRect';

export default function convertCropAnnotationToCropRectWithScale(
  cropAnnotations: ImageAnnotations['Crop'],
  annotationsViewport: Viewport,
  imageDimensions: { width: number; height: number }
) {
  let cropRect = convertCropAnnotationsToCropRect(cropAnnotations);
  if (!cropRect) return undefined;

  const { scaleFactor } = computeScaleFactorFromStoredViewport(
    annotationsViewport,
    imageDimensions
  );
  cropRect = cropRect.map((coord) => coord * scaleFactor) as [number, number, number, number];
  return cropRect;
}
